module.exports = __webpack_public_path__ + "static/check-by-auto-9bcf23d804e8970645727954b3044762.jpg";